import axios from "axios";
import { url, api } from "../../../../../env";

export const fetchStepStatus = async (persona, setStepStates, setStepsData, setLoading, setActiveStep, setProcessId) => {
    try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const response = await axios.get(`${url}/quote-process/status/${persona.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
            }
        });

        if (response.data && response.data.success) {
            const processData = response.data.data;
            const steps = processData.steps || [];

            // Actualizar datos completos de los pasos (para mostrar archivos, etc)
            if (setStepsData) {
                setStepsData(steps);
            }
            if (setProcessId && processData.process_id) {
                setProcessId(processData.process_id);
            }

            // Mapear estados para el UI
            const newStates = {
                ocularVisit: 'pending',
                confirmQuote: 'pending',
                uploadReceipt: 'pending',
                requestInvoice: 'pending'
            };

            steps.forEach(step => {
                if (step.step_type === 'ocular_visit') {
                    newStates.ocularVisit = step.status;
                } else if (step.step_type === 'confirm_quote') {
                    newStates.confirmQuote = step.status;
                } else if (step.step_type === 'upload_payment_proof') {
                    newStates.uploadReceipt = step.status;
                } else if (step.step_type === 'request_invoice') {
                    newStates.requestInvoice = step.status;
                }
                // 'add_insurance' lo maneja el botón Seguros del Header — no se trackea aquí.
                // 'register_plates' lo maneja el chip Placas del Header — tampoco se trackea aquí.
            });

            // Logic to set active step
            // 0: Mesa de Control, 1: Confirm, 2: Upload, 3: Invoice (Seguros vive en el Header).
            if (newStates.ocularVisit !== 'completed') {
                setActiveStep(0); // Mantener en Mesa de Control
            } else if (newStates.confirmQuote !== 'completed') {
                setActiveStep(1);
            } else if (newStates.uploadReceipt !== 'completed') {
                setActiveStep(2);
            } else if (newStates.requestInvoice !== 'completed') {
                setActiveStep(3);
            } else {
                setActiveStep(3); // All done
            }


            setStepStates(newStates);
            /*     setActiveStep(steps.findIndex(step => step.status === 'pending')); */
        }
    } catch (error) {
        setStepStates({
            confirmQuote: 'pending',
            uploadReceipt: 'pending',
            requestInvoice: 'pending'
        });
        setStepsData([]);
        setActiveStep(0);
        console.error('Error al obtener el estatus de la cotización:', error);
        // Si es 404 es normal al principio, no hacemos nada o dejamos todo en pending
    } finally {
        setLoading(false);
    }
};